var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            :root {\n            --dark: rgba(0, 32, 51, 1);\n            --light: rgba(255,255,255,0.8);\n            }\n            g[id] { display: none }\n            g[id]:target { display: inline }\n        "), /*#__PURE__*/React.createElement("path", {
    id: "_add",
    d: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_back",
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_casino",
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM7.5 18c-.83 0-1.5-.67-1.5-1.5S6.67 15 7.5 15s1.5.67 1.5 1.5S8.33 18 7.5 18zm0-9C6.67 9 6 8.33 6 7.5S6.67 6 7.5 6 9 6.67 9 7.5 8.33 9 7.5 9zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm0-9c-.83 0-1.5-.67-1.5-1.5S15.67 6 16.5 6s1.5.67 1.5 1.5S17.33 9 16.5 9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_close",
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_edit",
    d: "M18.41 5.8 17.2 4.59c-.78-.78-2.05-.78-2.83 0l-2.68 2.68L3 15.96V20h4.04l8.74-8.74 2.63-2.63c.79-.78.79-2.05 0-2.83zM6.21 18H5v-1.21l8.66-8.66 1.21 1.21L6.21 18zM11 20l4-4h6v4H11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_menu",
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_save",
    d: "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_delete",
    d: "M14 8c0-2.21-1.79-4-4-4S6 5.79 6 8s1.79 4 4 4 4-1.79 4-4zm3 2v2h6v-2h-6zM2 18v2h16v-2c0-2.66-5.33-4-8-4s-8 1.34-8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_down",
    d: "m7 10 5 5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_refresh",
    d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_spinner-p",
    opacity: 0.75,
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "_child-1",
    cx: 14.5,
    cy: 10.5,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    id: "_child-2",
    cx: 9.5,
    cy: 10.5,
    r: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "_child-3",
    d: "M22.94 12.66c.04-.21.06-.43.06-.66s-.02-.45-.06-.66c-.25-1.51-1.36-2.74-2.81-3.17-.53-1.12-1.28-2.1-2.19-2.91C16.36 3.85 14.28 3 12 3s-4.36.85-5.94 2.26c-.92.81-1.67 1.8-2.19 2.91-1.45.43-2.56 1.65-2.81 3.17-.04.21-.06.43-.06.66s.02.45.06.66c.25 1.51 1.36 2.74 2.81 3.17.52 1.11 1.27 2.09 2.17 2.89C7.62 20.14 9.71 21 12 21s4.38-.86 5.97-2.28c.9-.8 1.65-1.79 2.17-2.89 1.44-.43 2.55-1.65 2.8-3.17zM19 14c-.1 0-.19-.02-.29-.03-.2.67-.49 1.29-.86 1.86C16.6 17.74 14.45 19 12 19s-4.6-1.26-5.85-3.17c-.37-.57-.66-1.19-.86-1.86-.1.01-.19.03-.29.03-1.1 0-2-.9-2-2s.9-2 2-2c.1 0 .19.02.29.03.2-.67.49-1.29.86-1.86C7.4 6.26 9.55 5 12 5s4.6 1.26 5.85 3.17c.37.57.66 1.19.86 1.86.1-.01.19-.03.29-.03 1.1 0 2 .9 2 2s-.9 2-2 2zM7.5 14c.76 1.77 2.49 3 4.5 3s3.74-1.23 4.5-3h-9z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add",
    fill: "var(--dark)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#_add"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "add-white",
    fill: "var(--light)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#_add"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "back",
    fill: "var(--dark)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#_back"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "back-white",
    fill: "var(--light)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#_back"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "casino",
    fill: "var(--dark)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#_casino"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "casino-white",
    fill: "var(--light)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#_casino"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "close",
    fill: "var(--dark)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#_close"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "close-white",
    fill: "var(--light)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#_close"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    fill: "var(--dark)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#_edit"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "edit-white",
    fill: "var(--light)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#_edit"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "menu",
    fill: "var(--dark)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#_menu"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "menu-white",
    fill: "var(--light)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#_menu"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "save",
    fill: "var(--dark)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#_save"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "save-white",
    fill: "var(--light)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#_save"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "down",
    fill: "var(--dark)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#_down"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "down-white",
    fill: "var(--light)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#_down"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "delete",
    fill: "#f00"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#_delete"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "delete-white",
    fill: "#f55"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#_delete"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "refresh",
    fill: "var(--dark)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#_refresh"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "refresh-white",
    fill: "var(--light)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#_refresh"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "spinner",
    fill: "var(--dark)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#_spinner-p"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "spinner-white",
    fill: "var(--light)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#_spinner-p"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "child",
    fill: "var(--dark)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#_child-1"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#_child-2"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#_child-3"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "child-white",
    fill: "var(--light)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#_child-1"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#_child-2"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#_child-3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.8b256170ce8a80ac02f2b58af91e2d52.svg";
export { ForwardRef as ReactComponent };